import { ALACRITY_URL, PROD_ENVIRONMENT } from "../config/misc";

export const getEos = (privateKey = "") => {
  let api = PROD_ENVIRONMENT ? ALACRITY_URL : "https://hypertestapi.alacritys.net";
  let config = {};
  config = {
    chainId: PROD_ENVIRONMENT ? "adc25677cb57bb3cd827fc6e5df6158bcf72a7c404ab158af7aae59820b71d49" : "f2b641e3488f6d3d17447260c2fd950727e77138db09dc4efc1f2a9a34025d82",
    keyProvider: [privateKey],
    httpEndpoint: api,
    expireInSeconds: 60,
    broadcast: true,
    verbose: false,
    sign: true,
  };

  const eos = window.Eos(config);
  const eosapi = window.Eos.modules.api(config);
  return { eos, eosapi };
};
